<div *ngIf="sticky" class="push"></div>  
<div class="wrapper" [class.sticky]="sticky">
  <div class="container d-none d-xl-flex">
    <nav class="menu">
      <a routerLink="/" class="logo">
        <i class="icon-logo" [class.iconSticky]="sticky"></i>
      </a>
      <div class="spacer"></div>
      <a routerLink="/page/lite" routerLinkActive="active" class="link" i18n="@@front.header.broker">Lite</a>
      <a routerLink="/page/pro" routerLinkActive="active" class="link" i18n="@@front.header.exchange">Pro</a>
      <!-- <a [href]="links.apiDocs" target="_blank" class="link" i18n="@@front.header.api">API</a> -->
      <a routerLink="/prices" routerLinkActive="active" class="link" i18n="@@front.header.prices">Prices</a>
      <a routerLink="/otc" routerLinkActive="active" class="link" i18n="@@front.header.otc">OTC</a>
      <a routerLink="/page/fees" routerLinkActive="active" class="link" i18n="@@front.footer.fees">Fees</a>
      <a routerLink="/page/vip" routerLinkActive="active" class="link" i18n="@@front.footer.vip">VIP</a>
      <!-- <a [routerLink]="isLoggedIn() ? ['/affiliate-program'] : ['/invite-and-earn']" routerLinkActive="active" class="link" i18n="@@front.header.affiliate">Invite & Earn</a> -->
      <!-- <a routerLink="/invite-and-win-competition" routerLinkActive="active" class="link" i18n="@@front.header.contests">Contests</a> -->
      <!-- <a routerLink="/page/fees" routerLinkActive="active" class="link" i18n="@@front.header.fees">Fees</a> -->
      <!-- <a [href]="links.blog" target="_blank" class="link" i18n="@@front.header.blog">Blog</a> -->
      <!-- <a routerLink="/about-us" class="link" i18n="@@front.header.aboutUs">About Us</a> -->
    </nav>

    <nav class="account">
      <ng-container *ngIf="!isLoggedIn()">
        <a routerLink="/register" class="btn btn-fill" i18n="@@front.header.signup" [ga]="['Home Page Navigation', 'Sign Up']">Create Account</a>
        <div class="spacer"></div>
        <a routerLink="/login" class="btn btn-border" i18n="@@front.header.login" [ga]="['Home Page Navigation', 'Login']">Log In</a>
        <div class="spacer"></div>
        <a *ngIf="!isArabic" class="ar" [href]="getArLink()" [ga]="['Home Page Navigation', 'Ar Language']">العربية</a>
        <a *ngIf="isArabic" class="en" [href]="getEnLink()" [ga]="['Home Page Navigation', 'En Language']">English</a>
      </ng-container>
      <ng-container *ngIf="isLoggedIn()">
          <a routerLink="/dashboard" class="btn btn-fill" i18n="@@front.header.dashboard" [ga]="['Home Page Navigation', 'Dashboard']">Dashboard</a>
          <div class="spacer"></div>
          <a *ngIf="isVerified()" routerLink="/accounts" class="btn btn-border" i18n="@@front.header.wallets" [ga]="['Home Page Navigation', 'Accounts']">Wallets</a>
          <a *ngIf="!isVerified()" routerLink="/verification" class="btn btn-border" i18n="@@front.header.verify" [ga]="['Home Page Navigation', 'Verify']">Verify Now</a>
          <div class="spacer"></div>
          <app-user-menu [data]="user" [class.app-user-menu-sticky]="sticky && !isDarkMode"></app-user-menu>
      </ng-container>
    </nav>
  </div>

  <div class="container d-flex d-xl-none" [class.light]="sticky">
    <nav class="menu">
      <mobile-menu-site [data]="user" [contrast]="sticky && !isDarkMode" (toggleMenu)="getProfile()"></mobile-menu-site>
      <div class="spacer"></div>
      <a routerLink="/" class="logo">
        <i class="icon-logo" [class.iconSticky]="sticky"></i>
      </a>
      <div class="col"></div>
      <div>
        <a *ngIf="!isLoggedIn()" routerLink="/login" class="btn-sm btn-mobile" i18n="@@front.header.login">Login</a>
        <a *ngIf="isLoggedIn()" routerLink="/dashboard" class="btn-sm btn-mobile" i18n="@@front.header.dashboard">Dashboard</a>
      </div>
    </nav>
  </div>
</div>
